import { Challenge } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

import { UseGetAllPageSizeProps } from '../types';
import usePermittedQuery from '../usePermittedQuery';

export const GET_ALL_CHALLENGES_KEY = 'get-all-challenges';

export const useGetAllChallenges = ({ page = 0, size = 10 }: UseGetAllPageSizeProps) => {
  return usePermittedQuery<Challenge[]>(
    [
      ACCOUNT_TYPE.ADMIN,
      ACCOUNT_TYPE.ORG_ADMIN,
      ACCOUNT_TYPE.HOS_ADMIN,
      ACCOUNT_TYPE.THERAPIST,
    ],
    () => `/challenge?page=${page}&size=${size}`,
    {},
    [GET_ALL_CHALLENGES_KEY],
    {
      enabled: typeof page === 'number' && page >= 0,
      refetchOnWindowFocus: false,
    },
  );
};
